module.exports = __webpack_public_path__ + "static/media/homepage_title.7fd99084.png";